import { Controller } from "@hotwired/stimulus"

// An attached image whose stored object no longer resolves renders as a broken
// <img> — the browser paints the alt text and the card reads as broken UI. The
// server cannot see this: the attachment and its blob row are both present, so
// `attached?` is true; only the object behind them has gone (or the signed URL
// has expired). So degrade in the browser — hide the image and reveal the
// placeholder the component already renders for the "nothing attached yet"
// case.
//
//   <div data-controller="image-fallback">
//     <img data-image-fallback-target="image"
//          data-action="error->image-fallback#fallback">
//     <div data-image-fallback-target="placeholder" class="hidden">…</div>
//   </div>
export default class extends Controller {
  static targets = ["image", "placeholder"]

  // A cached failure fires `error` before this controller connects, so ask the
  // element directly as well: a finished load with no intrinsic width failed.
  imageTargetConnected(image) {
    if (image.complete && image.naturalWidth === 0) this.fallback()
  }

  fallback() {
    if (this.hasImageTarget) this.imageTarget.classList.add("hidden")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.remove("hidden")
  }
}
